// src/components/PageLoader.js
import React, { useEffect, useRef, useState } from "react";
import logo from "../images/logo.png";

export default function PageLoader({ loading }) {
  const [visible, setVisible] = useState(false);
  const startRef = useRef(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  useEffect(() => {
    const MIN_MS = 1500;

    if (loading) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      startRef.current = Date.now();
      setVisible(true);
      return;
    }

    const elapsed = Date.now() - startRef.current;
    const remaining = Math.max(0, MIN_MS - elapsed);

    timeoutRef.current = setTimeout(() => {
      setVisible(false);
      timeoutRef.current = null;
    }, remaining || 300);
  }, [loading]);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#02042b]"
      aria-hidden="true"
    >
      <div className="flex flex-col items-center gap-6 px-6">

        {/* CLEAN LOGO ONLY */}        
        <img
          src={logo}
          alt="Infinite Solution"
          className="w-28 h-28 sm:w-32 sm:h-32 md:w-40 md:h-40 object-contain select-none"
          draggable={false}
          onError={(e) => (e.currentTarget.style.display = "none")}
        />

        {/* TEXT */}
      

      </div>
    </div>
  );
}
